import { TableConfig } from '@common/types';

export const depotConfigDec = (config: TableConfig) => {
  const removeList = ['TripTemplateID', 'ZoneID'];
  config.columns = config?.columns.filter((col) => !removeList.includes(String(col.dataIndex)));
  return config;
};
